exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".s-container[data-v-e788b2e8]{width:100%}", ""]);

// exports
